// Fallback script to fix padding issues on About Us and Collabs pages
// This runs as a last resort if CSS fails

(function() {
  'use strict';

  // Check if we're on the correct pages
  const bodyClass = document.body.className;
  if (!bodyClass.includes('about-us') && !bodyClass.includes('collabs')) {
    return;
  }

  // Function to remove padding and constraints
  function fixPageLayout() {
    // Target both .section__page and .layout__content separately
    const sectionPage = document.querySelector('.section__page');
    const layoutContent = document.querySelector('.layout__content');

    if (sectionPage) {
      // Apply inline styles directly - this overrides everything
      sectionPage.style.setProperty('padding', '0px', 'important');
      sectionPage.style.setProperty('padding-top', '0px', 'important');
      sectionPage.style.setProperty('padding-right', '0px', 'important');
      sectionPage.style.setProperty('padding-bottom', '0px', 'important');
      sectionPage.style.setProperty('padding-left', '0px', 'important');
      sectionPage.style.setProperty('max-width', 'none', 'important');
      sectionPage.style.setProperty('margin', '0px', 'important');

      console.log('Applied inline styles to section__page');
    }

    if (layoutContent) {
      // Apply to layout__content as well
      layoutContent.style.setProperty('padding', '0px', 'important');
      layoutContent.style.setProperty('padding-top', '0px', 'important');
      layoutContent.style.setProperty('padding-right', '0px', 'important');
      layoutContent.style.setProperty('padding-bottom', '0px', 'important');
      layoutContent.style.setProperty('padding-left', '0px', 'important');
      layoutContent.style.setProperty('max-width', 'none', 'important');
      layoutContent.style.setProperty('margin', '0px', 'important');

      console.log('Applied inline styles to layout__content');
    }

    // Specifically target elements that have both classes
    const bothClasses = document.querySelector('.section__page.layout__content');
    if (bothClasses) {
      bothClasses.style.setProperty('padding', '0px', 'important');
      bothClasses.style.setProperty('max-width', 'none', 'important');
      bothClasses.style.setProperty('margin', '0px', 'important');

      console.log('Applied inline styles to element with both classes');
    }

    // Target ALL layout__content elements including banner
    const allLayoutContents = document.querySelectorAll('.layout__content');
    allLayoutContents.forEach((el, index) => {
      // Apply to all layout__content on these pages
      el.style.setProperty('padding', '0px', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('margin', '0px', 'important');
    });

    // Specifically target banner layout__content
    const bannerLayoutContent = document.querySelector('.section__row.layout__content.center');
    if (bannerLayoutContent) {
      bannerLayoutContent.style.setProperty('padding', '0px', 'important');
      bannerLayoutContent.style.setProperty('max-width', 'none', 'important');
      bannerLayoutContent.style.setProperty('margin', '0px', 'important');
      console.log('Applied styles to banner layout__content');
    }
  }

  // Run immediately
  fixPageLayout();

  // Run again after DOM is fully loaded (in case script runs early)
  document.addEventListener('DOMContentLoaded', fixPageLayout);

  // Run again after window loads (in case other scripts override)
  window.addEventListener('load', fixPageLayout);

  // Run again after a short delay (in case theme scripts load late)
  setTimeout(fixPageLayout, 100);
  setTimeout(fixPageLayout, 500);
  setTimeout(fixPageLayout, 1000);

  // CONTINUOUS MONITORING - Keep checking and removing padding
  setInterval(() => {
    const sectionPage = document.querySelector('.section__page');
    const layoutContent = document.querySelector('.layout__content');
    const isMobile = window.innerWidth <= 768;

    // Force remove padding every 100ms for the first 10 seconds
    if (sectionPage) {
      if (isMobile) {
        // On mobile, add horizontal padding
        sectionPage.style.setProperty('padding-left', '20px', 'important');
        sectionPage.style.setProperty('padding-right', '20px', 'important');
        sectionPage.style.setProperty('padding-top', '0px', 'important');
        sectionPage.style.setProperty('padding-bottom', '0px', 'important');
      } else {
        // On desktop, no padding
        sectionPage.style.setProperty('padding', '0px', 'important');
      }
      sectionPage.style.setProperty('max-width', 'none', 'important');
      sectionPage.style.setProperty('margin', '0px', 'important');
    }

    if (layoutContent) {
      if (isMobile) {
        // On mobile, ALL layout__content elements get horizontal padding
        layoutContent.style.setProperty('padding-left', '20px', 'important');
        layoutContent.style.setProperty('padding-right', '20px', 'important');
        layoutContent.style.setProperty('padding-top', '0px', 'important');
        layoutContent.style.setProperty('padding-bottom', '0px', 'important');
      } else {
        // On desktop, no padding
        layoutContent.style.setProperty('padding', '0px', 'important');
      }
      layoutContent.style.setProperty('max-width', 'none', 'important');
      layoutContent.style.setProperty('margin', '0px', 'important');
    }

    // For very small mobile
    if (isMobile && window.innerWidth <= 480) {
      if (sectionPage) {
        sectionPage.style.setProperty('padding-left', '16px', 'important');
        sectionPage.style.setProperty('padding-right', '16px', 'important');
      }
      if (layoutContent && !layoutContent.classList.contains('section__page')) {
        layoutContent.style.setProperty('padding-left', '16px', 'important');
        layoutContent.style.setProperty('padding-right', '16px', 'important');
      }
    }
  }, 100);

  // Stop continuous monitoring after 10 seconds
  setTimeout(() => {
    clearInterval();
  }, 10000);
})();